import PartnerPageHero from '@/components/partner/PartnerPageHero';
import PartnerOpportunitiesSections from '@/components/partner/PartnerOpportunitiesSections';
import PartnerInquiryForm from '@/components/partner/PartnerInquiryForm';

interface PartnerOpportunitiesPageProps {
  source?: string;
}

function PartnerOpportunitiesPage({ source = 'partner-opportunities' }: PartnerOpportunitiesPageProps) {
  const scrollToInquiry = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('partner-inquiry')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="fhxd-chrome-top">
      <PartnerPageHero ctaLabel="Partnership Inquiry" onCtaClick={scrollToInquiry} />
      <PartnerOpportunitiesSections />
      <PartnerInquiryForm source={source} />
    </div>
  );
}

export default PartnerOpportunitiesPage;
